import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isEnglishPath } from './paths';
import { de } from './de';
import { en } from './en';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const { pathname } = useLocation();
  const lang = isEnglishPath(pathname) ? 'en' : 'de';
  const value = useMemo(
    () => ({ lang, copy: lang === 'en' ? en : de }),
    [lang]
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const value = useContext(I18nContext);
  if (!value) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return value;
}
